import { supabase } from '@/integrations/supabase/client';

export const fetchSavedFeedPostIds = async (userId: string) => {
  const { data, error } = await supabase
    .from('saved_feed_posts')
    .select('post_id')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (error) {
    throw error;
  }

  return (data ?? []).map((item) => item.post_id);
};

export const fetchSavedFeedPosts = async (userId: string) => {
  const { data, error } = await supabase
    .from('saved_feed_posts')
    .select(`
      created_at,
      feed_posts!inner(
        id,
        user_id,
        content,
        created_at,
        edited_at,
        like_count,
        comment_count,
        photo_urls,
        video_urls,
        link_preview,
        topic_tags,
        profiles(display_name, avatar_url, postcode, country_code)
      )
    `)
    .eq('user_id', userId)
    .eq('feed_posts.is_deleted', false)
    .order('created_at', { ascending: false });

  if (error) {
    throw error;
  }

  return (data ?? [])
    .map((item: any) => item.feed_posts)
    .map((post: any) => (Array.isArray(post) ? post[0] : post))
    .filter(Boolean);
};

export const toggleSavedFeedPost = async (postId: string, userId: string, saved: boolean) => {
  if (saved) {
    return supabase.from('saved_feed_posts').delete().eq('post_id', postId).eq('user_id', userId);
  }

  return supabase.from('saved_feed_posts').insert({ post_id: postId, user_id: userId });
};
